module.exports = __webpack_public_path__ + "static/media/mealplan60fit.ea6455d1.png";